import { render, staticRenderFns } from "./TextAutoHeightIcon.vue?vue&type=template&id=7a3c8388&"
import script from "./TextAutoHeightIcon.vue?vue&type=script&lang=js&"
export * from "./TextAutoHeightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports